/**
 * Created by Caroline on 2019/11/25 0025.
 *
 */
export const scale = state => {
  return state.win.screenWScale > state.win.screenHScale ? state.win.screenHScale : state.win.screenWScale
}

export const modeData = state => state.modeData
export const shareData = state => state.shareData
export const lottery = state => state.lottery
export const lotteryWinners = state => state.lotteryWinners

export const blessingList = state => {
  state.blessingList.forEach(item => {
    item = initBlessing(item)
  })
  // console.log("state.blessingList", state.blessingList);
  return state.blessingList
}
export const newBlessing = state => {
  return initBlessing(state.newBlessing)
}
function initBlessing (blessing) {
  // console.log("blessing.user", blessing.user);
  if(blessing){
    blessing.icon = blessing.user ? blessing.user.headImgUrl : this.$store.state.headDefault
    if(blessing.identifyType === 3 || blessing.identifyType === 4){
      blessing.identifyName = blessing.identify
    }
  }
  return blessing
}



// WEBPACK FOOTER //
// ./src/store/getters.js